module.exports = __webpack_public_path__ + "img/ic_challenge_cta.ad74f67a.svg";